export const ETAPPIO_COMPANY = {
  legalName: 'Etappio AB',
  tradeName: 'Etappio',
  organizationNumber: '559573-5969',
  // Säte: for legal texts only, not shown in contact details (address policy).
  registeredOffice: 'Saltsjö-Boo',
  streetAddress: 'Medborgarplatsen 25',
  postalCode: '118 72',
  locality: 'Stockholm',
  email: 'support@etappio.se',
  website: 'https://etappio.se'
} as const;

export const ETAPPIO_COMPANY_VISITING_ADDRESS =
  `${ETAPPIO_COMPANY.streetAddress}, ${ETAPPIO_COMPANY.postalCode} ${ETAPPIO_COMPANY.locality}`;
